import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  TableHead,
  TableSortLabel,
  IconButton,
  FormControl,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import './report.less';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import PageHeader from '../common/PageHeader';
import ReportButtons from './ReportButtons';
import {
  BuildObject,
  cloneDeep,
  ExpandAll,
  GenerateAbsoluteURL,
  getCurrentPayCycle,
  removeDuplicates,
  SortArray,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import { getFormattedHeaders, getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import { Add, Remove } from '@material-ui/icons';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage';

export default class ARReimbursementCostReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      reportData: [],
      originalReportData: [],
      showReport: false,
      marketMasterData: [],
      propertyTypeMasterData: [],
      market: [{ marketName: 'All' }],
      propertyType: [{ propertyTypeName: 'All' }],
      order: 'desc',
      orderByColumn: 'marketName',
      rows: [],
      payCycleData: [],
      payCycle: null,
      showDetails: true,
      supervisorEmployee: [{ employeeName: 'All' }],
      supervisorEmployeeMasterData: [],
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false
    };

    this.baseState = this.state;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.GetMasterData();
  }

  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  handleDateChange = (date, name) => {
    this.setState({
      [name]: moment(date).format(DateFormat)
    });
  };

  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetPayCycle,
        key: 'payCycleData'
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: 'propertyTypeMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'supervisorEmployeeMasterData'
      }
    ])
      .then(
        ({
          payCycleData,
          propertyTypeMasterData,
          marketMasterData,
          supervisorEmployeeMasterData
        }) => {
          this._asyncRequest = null;
          if (marketMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }

          let { payCycle } = this.state;
          if (payCycle === null) {
            const date = getCurrentPayCycle();
            payCycle = (payCycleData.data || []).find(x => x.payCycle === (date[1] + '-' + date[0]));
          }

          this.setState({
            propertyTypeMasterData: propertyTypeMasterData.data,
            marketMasterData: marketMasterData.data,
            payCycleData: (payCycleData.data || []).filter(x => x.payCycleEnd !== x.payCycleStart),
            supervisorEmployeeMasterData: (supervisorEmployeeMasterData.data || []),
            payCycle: payCycle
          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked){
              this.GetARReimbursementCostReport();
            }            
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  GetARReimbursementCostReport = () => {
    const { market, propertyType, payCycleData, showDetails, supervisorEmployee } = this.state;
    let { payCycle } = this.state;
    if (payCycle === null) {
      const date = getCurrentPayCycle();
      payCycle = (payCycleData || []).find(x => x.payCycle === (date[1] + '-' + date[0]));
    }

    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const propertyTypeId = _.cloneDeep(propertyType.map((x) => x.propertyTypeId));
    const supervisorId = _.cloneDeep(supervisorEmployee.map((x) => x.ultiProEmployeeId));

    const params = {
      startDate: moment(payCycle.payCycleStart).format(DateFormat),
      endDate: moment(payCycle.payCycleEnd).format(DateFormat),
      employeeId: '0',
      propertyId: '0',
      marketId: (marketId.join('|') === undefined || marketId.join('|') === '') ? '0' : marketId.join('|'),
      propertyTypeId: (propertyTypeId.join('|') === undefined || propertyTypeId.join('|') === '') ? '0' : propertyTypeId.join('|'),
      supervisorId: supervisorId.join('|'),
      showDetails: 1

    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Json.GetARReimbursementCost,
        params,
        key: 'reportData'
      }
    ])
      .then(({ reportData }) => {
        this._asyncRequest = null;
        if (reportData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }

        reportData.data = (reportData.data || []).map(y => {
          if (y.IsChild === 0) {
            y.isExpand = this.state.showDetails;
          }
          return y;
        });

        const obj = ExpandAll(
          (reportData.data || []),
          cloneDeep((reportData.data || []).filter(x => x.IsChild === 0)),
          showDetails,
          showDetails,
          'MarketName',
          'MarketPropertyType'
        );

        this.setState({
          originalReportData: (obj.filterdOriginalReportData || []),
          reportData: cloneDeep((obj.filterdReportData || []).filter(x => x.IsChild === 0)),
          configuration: reportData.config,
          showReport: true,
          isSubmitButtonClicked: true,
          payCycle: payCycle,
          rows: this.renderTableRow(SortArray(cloneDeep((obj.filterdReportData || []).filter(x => x.IsChild === 0)), (obj.filterdOriginalReportData || []), this.state.order, this.state.orderByColumn, 'MarketName', 'MarketPropertyType'), reportData.config, obj.filterdOriginalReportData)
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  handleRequestSort = (property, type) => {
    const isAsc = this.state.orderByColumn === property && this.state.order === 'asc';
    let rows = [];
    rows = [...rows, ...this.renderTableRow(
      SortArray((this.state.reportData || []), this.state.originalReportData, isAsc ? 'desc' : 'asc', property, 'MarketName', 'MarketPropertyType'),
      this.state.configuration,
      this.state.originalReportData
    )];
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderByColumn: property,
      rows
    });
  }

  renderTable = (rows) => {
    const { order, orderByColumn, configuration } = this.state;
    return (
      <Table className="reportTable" id="rptTable">
        <TableHead className='background-table-header'>
          <TableRow>
            <TableCell className='right-border'></TableCell>
            <TableCell colSpan={4} align='center' className='right-border'>
              Current Period
                </TableCell>
            <TableCell colSpan={2} align='center' className='right-border'>
              Prior Period
                </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>

          </TableRow>
        </TableHead>
        <TableHead className='background-table-header'>
          <TableRow>
            {configuration?.filter(x => x.isVisible === true).map((config) => (
              <TableCell
                className='right-border'
                key={config.dbColumn}
                sortDirection={orderByColumn === config.dbColumn ? order : false}
                width='120px'
              >
                {
                  <TableSortLabel
                    active={orderByColumn === config.dbColumn}
                    direction={orderByColumn === config.dbColumn ? order : 'asc'}
                    onClick={() => { this.handleRequestSort(config.dbColumn, config.dataFormat); }}
                  >
                    {config.dataFormat !== undefined && config.dataFormat === 'Text'
                      ? getFormattedHeaders(config.uiColumn, config.dataFormat)
                      : config.dataFormat !== undefined ? getFormattedHeaders(config.uiColumn, 'Number') : config.uiColumn
                    }
                  </TableSortLabel>
                }
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  resetPage = () => {
    const { payCycleData } = this.state;
    let { payCycle } = this.state;
    const date = getCurrentPayCycle();
    payCycle = (payCycleData || []).find(x => x.payCycle === (date[1] + '-' + date[0]));

    this.setState({
      showReport: false,
      market: [{ marketName: 'All' }],
      propertyType: [{ propertyTypeName: 'All' }],
      supervisorEmployee: [{ employeeName: 'All' }],
      payCycle,
      showDetails: true,
      groupBy: 'Property',
      isSubmitButtonClicked: false
    }, () => {
      this.GetMasterData();
    });    
  };

  handlePrintClick = () => {
    this.setState(
      {
        printPage: true
      },
      window.print()
    );
  };

  handleChange = (_e, value, name, optionLabel, isMultiple = true) => {
    if (isMultiple === true) {
      if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
        if (value && value.length === 0) {
          value = [{ [optionLabel]: 'All' }];
          this.setState({ [name]: value });
        } else if ((value || []).find(x => x[optionLabel] === 'All')) {
          this.setState({ [name]: [{ [optionLabel]: 'All' }] });
        } else {
          this.setState({ [name]: value });
        }
      } else {
        value = (value || []).filter(x => x[optionLabel] !== 'All');
        if (value && value.length === 0) {
          value = [{ [optionLabel]: 'All' }];
        }
        this.setState({ [name]: value });
      }
    } else {
      this.setState({ [name]: value });
    }
  };

  handleClick = (data) => {
    const { originalReportData, reportData, configuration, order, orderByColumn } = this.state;
    const object = BuildObject(reportData, originalReportData, 'MarketPropertyType', data, true, 'MarketName');
    this.setState({
      originalReportData: object.originalReportData,
      reportData: object.reportData,
      rows: this.renderTableRow(SortArray(cloneDeep((object.reportData || []).filter(x => x.IsChild === 0)), (object.originalReportData || []), order, orderByColumn, 'MarketName', 'MarketPropertyType'), configuration, object.originalReportData)
    });
  }

  renderTableRow = (data, columns, originalReportData) => {
    return this.renderTableCell(
      data,
      columns,
      [],
      0,
      originalReportData
    );
  };

  renderTableCell = (groupedData, columns, tableCell = [], rowCount = 0, originalReportData) => {
    groupedData.forEach((d, i) => {
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const key = i + '_' + rowCount + '_' + i;
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          {
            columns.map((col, index) => {
              return (
                <>
                  {
                    col.isVisible
                      ? <TableCell key={key + index} className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} width={index === 0 ? '250px' : '120px'}>
                        <>
                          {index === 0 && d.IsChild === 0 &&
                            <IconButton
                              key={key + index}
                              aria-label="expand row"
                              size="small"
                              style={{ padding: '0px', cursor: 'pointer' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleClick(d);
                              }}
                            >
                              {(d.isExpand !== true
                                ? <Add className="collapse-button" fontSize={'small'} />
                                : <Remove className="collapse-button" fontSize={'small'} />)}
                            </IconButton>
                          }

                          <span className={index === 0 && d.IsChild === 1 ? 'paddingLeft' : ''}>
                            {getFormattedValues(d[col.dbColumn], col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}
                          </span>
                        </>
                      </TableCell>
                      : ''
                  }

                </>
              );
            })
          }

        </TableRow>
      );
      rowCount++;
    });
    if (groupedData?.length > 0) {
      const key = tableCell.length + '_' + rowCount + '_' + tableCell.length;
      const evenOddClass = tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          {
            columns.map((col, i) => {
              return (<>
                {col.isVisible
                  ? <TableCell key={key + i} className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} id={'grandTotal' + i}>
                    <b> {
                      col.dataFormat === 'Text'
                        ? getFormattedValues('Grand Total', col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')
                        : getFormattedValues(
                          originalReportData.filter(x => x.IsChild === 0).reduce((total, obj) => (parseFloat(obj[col.dbColumn]) + parseFloat(total)), 0), col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')
                    }
                    </b>
                  </TableCell>
                  : ''}
              </>);
            })
          }
        </TableRow>
      );
      rowCount++;
    }

    if (groupedData?.length > 0) {
      const key = tableCell.length + '_' + rowCount + '_' + tableCell.length;
      const evenOddClass = tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          <TableCell colSpan={3} align='right' className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}><b>Current Annual Cost per Tenant </b></TableCell>
          <TableCell align='right' className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} id={'currentAnnualCostPerTenant'}>
            <b>
              {getFormattedValues(
                (originalReportData.filter(x => x.IsChild === 0).reduce((total, obj) => (parseFloat(obj.CurrentCostAnnual) + parseFloat(total)), 0)) / 24, 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}
            </b>
          </TableCell>
          <TableCell align='right' className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} ></TableCell>
          <TableCell align='right' className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} ></TableCell>
          <TableCell align='right' className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} ></TableCell>
          <TableCell align='right' className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} ></TableCell>
          <TableCell align='right' className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} ></TableCell>
        </TableRow>
      );
      rowCount++;
    }

    if (groupedData?.length > 0) {
      const key = tableCell.length + '_' + rowCount + '_' + tableCell.length;
      const evenOddClass = tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'} colSpan={2} ></TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'} align='center'>
            <b>
              Annual
                  </b>
          </TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'} align='center'>
            <b>
              Per Pay Period
                  </b>
          </TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
        </TableRow>
      );
      rowCount++;
    }
    if (groupedData?.length > 0) {
      const filteredData = originalReportData.filter(x => x.IsChild === 1);
      const totalAnnualCostConfig = filteredData?.length > 0 ? filteredData[0].TotalAnnualCostConfig : 0;
      const key = tableCell.length + '_' + rowCount + '_' + tableCell.length;
      const evenOddClass = tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          <TableCell colSpan={2} className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'} align='right'>
            <b>Total Current A/R Cost:</b>
          </TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'} id={'annualARCost'}>
            <b>
              {getFormattedValues(totalAnnualCostConfig, 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}
            </b>
          </TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'} id={'payPeriodARCost'}>
            <b>
              {getFormattedValues((totalAnnualCostConfig / 24), 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}

            </b>
          </TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
          <TableCell className={evenOddClass + 'rpt-topBorder' + ' year-end-padding rpt-topBorder'}></TableCell>
        </TableRow>
      );
      rowCount++;
    }
    if (groupedData?.length <= 0) {
      tableCell.push(<TableRow> <TableCell colSpan={8} align='center'>No records found</TableCell> </TableRow>);
    }
    return tableCell;
  }

  downloadFile = (fileMimeType, type, isPrint = false) => {
    const { market, propertyType, payCycle, showDetails, supervisorEmployee } = this.state;
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const propertyTypeId = _.cloneDeep(propertyType.map((x) => x.propertyTypeId));
    const supervisorId = _.cloneDeep(supervisorEmployee.map((x) => x.ultiProEmployeeId));

    const dataValue = [
      {
        key: 'StartDate',
        value: moment(payCycle.payCycleStart).format(DateFormat)
      },
      {
        key: 'EndDate',
        value: moment(payCycle.payCycleEnd).format(DateFormat)
      },
      {
        key: 'ShowDetails',
        value: showDetails ? 1 : 0
      }
    ];
    dataValue.push({ key: 'MarketId', value: (marketId.join('|') === undefined || marketId.join('|') === '') ? '0' : marketId.join('|') });
    dataValue.push({ key: 'PropertyTypeId', value: (propertyTypeId.join('|') === undefined || propertyTypeId.join('|') === '') ? '0' : propertyTypeId.join('|') });
    dataValue.push({ key: 'PropertyId', value: '0' });
    dataValue.push({ key: 'EmployeeId', value: '0' });
    dataValue.push({ key: 'supervisorId', value: (supervisorId.join('|') === undefined || supervisorId.join('|') === '') ? '0' : supervisorId.join('|') });

    const url = GenerateAbsoluteURL(dataValue, [], 'AR%20Reimbursement%20Cost%20Report', type, false, true);

    downloadReport(
      url,
      'Centralized AR Reimbursement Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  handleRadioChange = (value, fieldName, isCall = false, showDetails = false) => {
    const { originalReportData, reportData, configuration, order, orderByColumn } = this.state;

    const obj = ExpandAll(originalReportData, reportData, value, showDetails, 'MarketName', 'MarketPropertyType');
    this.setState({
      originalReportData: obj.filterdOriginalReportData,
      reportData: obj.filterdReportData,
      rows: this.renderTableRow(SortArray(cloneDeep((obj.filterdReportData || []).filter(x => x.IsChild === 0)), (obj.filterdOriginalReportData || []), order, orderByColumn, 'MarketName', 'MarketPropertyType'), configuration, obj.filterdOriginalReportData),
      [fieldName]: value
    }, () => {
      if (isCall === true) {
        this.GetARReimbursementCostReport();
      }
    });
  }

  render() {
    const {
      showMain,
      reportData,
      payCycleData,
      showReport,
      marketMasterData,
      propertyTypeMasterData,
      rows,
      showDetails,
      supervisorEmployeeMasterData
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }

    if (propertyTypeMasterData.find(x => x.propertyTypeName === 'All') === undefined) {
      propertyTypeMasterData.unshift({ propertyTypeName: 'All' });
    }

    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }

    return (
      <div>
        {showMain
          ? (
            <Reports></Reports>
          )
          : (
            <>
              <PageHeader
                key={'Centralized_AR_Reimbursement_Report'}
                title={'Centralized AR Reimbursement Report'}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                AR Reimbursement Cost Report
            </PageHeader>
              <Grid
                container
                spacing={3}
                className="no-print row bottom-xs"
                style={{ marginLeft: '10px' }}
              >
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.market}
                    onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                    id="tags-standard"
                    options={removeDuplicates(marketMasterData, 'marketName')}
                    limitTags={1}
                    getOptionLabel={(option) => option.marketName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Market"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.propertyType}
                    onChange={(e, val) => this.handleChange(e, val, 'propertyType', 'propertyTypeName')}
                    id="tags-standard"
                    options={removeDuplicates(propertyTypeMasterData, 'propertyTypeName')}
                    limitTags={1}
                    getOptionLabel={(option) => option.propertyTypeName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Property Type"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.supervisorEmployee}
                    onChange={(e, val) => {
                      this.handleChange(e, val, 'supervisorEmployee', 'employeeName');
                    }
                    }
                    id="tags-standard"
                    options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                    limitTags={1}
                    getOptionLabel={(option) => option.employeeName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Supervisor Name"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} lg={2} style={{ marginTop: '10px' }}>
                  <Autocomplete
                    blurOnSelect
                    value={this.state.payCycle}
                    onChange={(e, val) => this.handleChange(e, val, 'payCycle', 'payCycle', false)}
                    id="tags-standard"
                    options={removeDuplicates(payCycleData, 'payCycle')}
                    getOptionLabel={(option) => option.payCycle}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Pay Period"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} lg={2}>
                  <FormControl component="fieldset">
                    <FormControlLabel
                      key={'checkbox_1'}
                      value={showDetails}
                      control={
                        <Checkbox
                          color="primary"
                          checked={showDetails}
                          onChange={(event) => {
                            this.handleRadioChange(event.target.checked, 'showDetails', false, true);
                          }}
                        />
                      }
                      label={'Show Details'}
                      labelPlacement="end"
                    />
                  </FormControl>
                </Grid>
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.GetARReimbursementCostReport}
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.downloadFile}
                  data={reportData}
                  hideAdvanceLink={true}
                />
              </Grid>
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (reportData === null || reportData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {showReport && (reportData == null || reportData.length === 0) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {showReport && reportData !== null && reportData.length > 0 && (
                <div className="container" style={{ marginTop: '1rem' }}>
                  <TableWithPaginations
                    tableData={rows}
                    renderTable={this.renderTable}
                    order={this.state.order}
                    oBy={this.state.orderByColumn}
                  />
                </div>
              )}
            </>
          )
        }
      </div>
    );
  }
}
